import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Header from "../../components/Header";
import FooterComponent from "../Footer";
import LogoLoaderLottie from "./LogoLoaderLottie";

// import { useSelector } from "react-redux";
function Loading() {
  return (
    <Box>
      {/* <div
      style={{
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
      }}
    >
      <div >
        <img src={"../../../assets/images/loading.gif"} />
      </div>
    </div> */}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
        }}
        position="fixed"
      >
        {/* <CircularProgress /> */}
        <LogoLoaderLottie />
      </Box>
      <Box position="fixed" left="0" top="0" right="0">
        <Header />
      </Box>
      <Box position="fixed" left="0" bottom="0" right="0">
        <FooterComponent />
      </Box>
    </Box>
  );
}

export default Loading;
